import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { E_FLOW_HEX, L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const PUMP_CONFIG = {
    type: ERFElement.Pump,
    icon: 'Pump_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной материальный поток',
                    position: Position.Left,
                    style: { top: 35, left: 10, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow',
                    type: 'source',
                    name: 'Выходной материальный поток',
                    position: Position.Right,
                    style: { top: 20, right: 11, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_energy_flow',
                    type: 'target',
                    name: 'Входной энергетический поток',
                    position: Position.Bottom,
                    style: { bottom: 29, left: 33, background: E_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 63, left: 11, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 63, right: 20, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFPumpNode.config.js.map